<template>
  <div class="right-container">
    <div class="right-header flex-between">
      <div class="flex-row-start">
        <a
          href="javascript:;"
          class="sign column"
          :class="{ active: classType == index }"
          @click="onSelectType(index)"
          v-for="(item, index) in tabList"
          :key="index"
          >{{ item.title }}</a
        >
      </div>
      <div class="flex-row-end">
        <div class="circle"></div>
        <div class="right-header-text">
          累计发布作业：<span class="num">{{ homeWorkTotalCount }}</span>
        </div>
        <div class="right-header-text">
          未截止：<span class="num">{{ totalIngCount }}</span>
        </div>
        <div class="right-header-text">
          已截止：<span class="num">{{
            homeWorkTotalCount - totalIngCount
          }}</span>
        </div>
      </div>
    </div>
    <template v-if="classType == 0">
      <div
        class="right-main class-list-container right-main-list"
        v-if="isNull"
      >
        <div
          class="item-box flex-between"
          v-for="(v, i) in homeWorkList"
          :key="i"
        >
          <div class="item-left">
            <span class="flag" :class="{ active: v.is_show }"></span>
            <div class="item-top info">作业名称：{{ v.name }}</div>
            <div class="item-center info">
              <span
                >学段：<span class="info-value">{{ v.stage_name }}</span></span
              >
              <span
                >学科：<span class="info-value">{{
                  v.subject_name
                }}</span></span
              >
              <span
                >试题数量：<span class="info-value">{{
                  v.question_count
                }}</span></span
              >
            </div>
            <div class="item-bottom info">
              下发班级：{{ v.class_name }}（ID:{{ v.class_code }}）
            </div>
          </div>
          <div class="item-right">
            <div class="item-right-info">
              有效期：{{ v.start_time }} 至 {{ v.end_time }}
            </div>
            <div class="item-right-info right-button flex-between">
              <el-button
                class="item-right-button"
                type="primary"
                size="small"
                @click="onHomeWorkCase(v)"
                >作业情况</el-button
              >
              <el-button
                class="item-right-button"
                type="danger"
                size="small"
                @click="onSetHomeWork(v)"
                >修改设置</el-button
              >
            </div>
          </div>
        </div>

        <div class="list-page">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="homeWorkQuery.page"
            :page-size="homeWorkQuery.pageSize"
            :total="homeWorkTotalCount"
            @current-change="homeWorkPageChange"
          ></el-pagination>
        </div>
      </div>
      <div class="right-main column" v-else>
        <img src="../../assets/images/list_null.png" alt="" srcset="" />
        <div class="null">暂无数据~~</div>
      </div>
    </template>
    <template v-if="classType == 1">
      <div
        class="right-main class-list-container  right-main-list"
        v-if="isPaperNull"
      >
        <div
          class="item-box flex-between"
          v-for="(item, index) in paperList"
          :key="index"
        >
          <div class="item-left">
            <!-- <span class="flag active"></span> -->
            <div class="item-top info">试卷名称：{{ item.name }}</div>
            <div class="item-center info">
              <span
                >学段：<span class="info-value">{{
                  item.stage_name
                }}</span></span
              >
              <span
                >学科：<span class="info-value">{{
                  item.subject_name
                }}</span></span
              >
              <span
                >试题数量：<span class="info-value">{{ item.num }}</span></span
              >
            </div>
          </div>
          <div class="item-right">
            <div class="item-right-info">生成时间：{{ item.create_time }}</div>
            <div class="item-right-info right-button flex-between">
              <el-button
                class="item-right-button"
                type="primary"
                size="small"
                @click="onHomeworkTo(item)"
                >下发作业</el-button
              >
              <el-button
                class="item-right-button"
                type="primary"
                size="small"
                @click="onUpdatePaper(item)"
                >修改试题</el-button
              >
              <el-button
                class="item-right-button"
                type="danger"
                size="small"
                @click="onDeletePaper(item.code)"
                >删除</el-button
              >
            </div>
          </div>
        </div>

        <div class="list-page">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="homeWorkQuery.page"
            :page-size="homeWorkQuery.pageSize"
            :total="paperTotalCount"
            @current-change="paperPageChange"
          ></el-pagination>
        </div>
      </div>
      <div class="right-main column" v-else>
        <img src="../../assets/images/list_null.png" alt="" srcset="" />
        <div class="null">暂无数据~~</div>
      </div>
    </template>
    <el-dialog :title="dialog.title" :visible.sync="dialog.status" fullscreen>
      <div class="right-main right-main-edit">
        <div class="form-box">
          <el-form
            :rules="rules"
            ref="formRef"
            class="right-form"
            :model="form"
            label-width="100px"
          >
            <el-form-item label="作业名称" prop="name">
              <el-input v-model="form.name" class="edit-input"></el-input>
            </el-form-item>
            <el-form-item label="截止时间" prop="time">
              <el-date-picker
                v-model="form.time"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                align="right"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="下发班级" prop="class_code">
              <div class="class-box-cheak">
                <el-checkbox-group v-model="form.class_code">
                  <el-checkbox
                    v-for="(n, i) in classList"
                    :key="i"
                    :label="n.class_code"
                    >{{ n.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>
            <div class="flex-row">
              <el-button type="primary" @click="onSubmit" class="save-but"
                >确定下发</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogTime.title"
      :visible.sync="dialogTime.status"
      width="650px"
    >
      <div class="dialog-time-main ">
        <div class="form-time-box">
          <el-form
            :rules="rulesTime"
            ref="formTimeRef"
            :model="homeWorkForm"
            label-width="100px"
          >
            <el-form-item label="截止时间" prop="time">
              <el-date-picker
                v-model="homeWorkForm.time"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                align="right"
              >
              </el-date-picker>
            </el-form-item>
            <div class="flex-row">
              <el-button type="primary" @click="onSubmitHomeWork"
                >确定保存</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogCase.title"
      :visible.sync="dialogCase.status"
      class="dialog-padding-0 dialog-case"
      width="950px"
    >
      <div class="dialog-case-header flex-between">
        <div class="c-item-box c-item-a">
          <div class="c-item">
            <div class="c-title flex-row-start">
              <img
                :src="classHomeworkInfo.class_img"
                alt=""
                class="class-img"
                v-if="classHomeworkInfo.class_img"
              />
              <div class="class-img" v-else></div>
              <div class="c-title-text">
                本次作业未交<span class="c-bb4850">{{
                  classHomeworkInfo.not_count
                }}</span
                >人/共{{ classHomeworkInfo.total_count }}人
              </div>
            </div>
            <div class="m10 ">未交名单：</div>
            <div class="not-list-box">
              <span
                class="n-item"
                v-for="(not_value, not_key) in classHomeworkInfo.list"
                :key="not_key"
                >{{ not_value.u_name }}</span
              >
            </div>
          </div>
        </div>
        <div class="c-item-box c-item-b">
          <div class="c-item">
            <div class="c-title">班级得分率</div>
            <div class="statistical-chart-box flex-between">
              <div class="s-c-item">
                <div class="c-chart">
                  <template>
                    <svg-bar
                      :value="classHomeworkInfo.class_accuracy"
                      :options="options"
                    ></svg-bar>
                  </template>
                </div>
                <div>本次</div>
              </div>
              <div class="s-c-item">
                <div class="c-chart">
                  <template>
                    <svg-bar
                      :value="classHomeworkInfo.last_class_accuracy"
                      :options="optionsEd"
                    ></svg-bar>
                  </template>
                </div>
                <div>上次</div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-item-box c-item-c">
          <div class="c-item">
            <div>
              <div class="c-title flex-between">
                <div class="ml-8">
                  <span class="line"></span>班级最<span class="c-40B8EE"
                    >高</span
                  >得分率
                </div>
                <span class="c-40B8EE">{{ classHomeworkInfo.max }}%</span>
              </div>
              <div class="c-user-list">
                <span
                  class="n-item"
                  v-for="(max_value, max_key) in classHomeworkInfo.max_list"
                  :key="max_key"
                  >{{ max_value.u_name }}</span
                >
              </div>
            </div>
            <div>
              <div class="c-title flex-between">
                <div class="ml-8">
                  <span class="line"></span>班级最<span class="c-40B8EE"
                    >低</span
                  >得分率
                </div>
                <span class="c-bb4850">{{ classHomeworkInfo.min }}%</span>
              </div>
              <div class="c-user-list">
                <span
                  class="n-item"
                  v-for="(min_value, min_key) in classHomeworkInfo.min_list"
                  :key="min_key"
                  >{{ min_value.u_name }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-case-content">
        <div class="c-head flex-between">
          <div>
            <span class="h-title">已交作业详情</span>
            <span
              >（本次作业共<span class="c-40B8EE">{{ homeWorkNum }}</span
              >题）</span
            >
          </div>
          <div>
            <el-button type="primary" icon="el-icon-download" size="small"
              >下载</el-button
            >
          </div>
        </div>
        <div class="table-box">
          <template>
            <el-table
              :data="classHomeworkList"
              height="300"
              border
              style="width: 100%"
            >
              <el-table-column prop="name" label="学生姓名"> </el-table-column>
              <el-table-column prop="u_guid" label="学生ID"> </el-table-column>
              <el-table-column prop="update_time" label="提交时间">
              </el-table-column>
              <el-table-column prop="correct_question_num" label="正确数">
              </el-table-column>
              <el-table-column prop="error_question_num" label="错误数">
              </el-table-column>
              <el-table-column prop="accuracy" label="正确率">
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="page-box flex-row">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="classHomeworkTotal"
            :current-page="classHomeworkQuery.page"
            :page-size="classHomeworkQuery.pageSize"
            @current-change="classHomeworkPageChange"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import "../../assets/css/dialog.css";

export default {
  components: {},
  data() {
    return {
      form: {
        name: "",
        time: "",
        class_code: [],
      },
      homeWorkForm: {
        time: "",
      },
      classType: 0,
      tabList: [{ title: "发布历史" }, { title: "作业档案" }],
      paperList: [],
      paperQuery: {
        page: 0,
        pageSize: 5,
      },
      isNull: true,
      isPaperNull: true,
      paperTotalCount: 0,
      paperIng: {},
      dialog: { status: false, title: "下发作业" },
      dialogTime: { status: false, title: "修改设置" },
      dialogCase: { status: false, title: "作业情况" },
      classList: [],
      rules: {
        name: [{ required: true, message: "请输入试题名称", trigger: "blur" }],
        time: { required: true, message: "请输入截止时间", trigger: "blur" },
        class_code: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个班级",
            trigger: "change",
          },
        ],
      },
      rulesTime: {
        time: { required: true, message: "请输入截止时间", trigger: "blur" },
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      homeWorkTotalCount: 0,
      totalIngCount: 0,
      homeWorkList: [],
      homeWorkQuery: {
        page: 0,
        pageSize: 5,
      },
      classHomeworkList: [],
      classHomeworkQuery: {
        page: 0,
        pageSize: 10,
      },
      classHomeworkTotal: 0,
      homeWorkNum: 0,
      classHomeworkInfo: {},
    };
  },
  created() {
    this.getToHomeWorkList();
  },
  computed: {
    options() {
      return {
        radius: 50,
        text: function(value) {
          return (
            this.htmlifyNumber(value) +
            '<span style="font-size: 0.4em;">%</span>'
          );
        },
        textColor: "rgb(249,187,0)",
        pathColors: ["#EEEEEE", "rgb(249,187,0)"],
      };
    },
    optionsEd() {
      return {
        radius: 50,
        text: function(value) {
          return (
            this.htmlifyNumber(value) +
            '<span style="font-size: 0.4em;">%</span>'
          );
        },
        textColor: "rgb(64,184,238)",
        pathColors: ["#EEEEEE", "rgb(64,184,238)"],
      };
    },
  },
  methods: {
    getToHomeWorkList() {
      this.onLoading();
      this.getRequest(
        "/wenjiaoopne/kc/teacher/toHomeWorkList",
        this.homeWorkQuery
      )
        .then((result) => {
          this.loading.close();
          this.totalIngCount = result.data.total_ing_count;
          this.homeWorkTotalCount = result.data.total_count;
          this.homeWorkList = result.data.list;
          this.isNull = this.homeWorkList.length > 0;
        })
        .catch(() => {
          this.loading.close();
        });
    },
    getUserPaperList() {
      this.getRequest(
        "/wenjiaoopne/kc/basket/work/userPaperList",
        this.paperQuery
      )
        .then((result) => {
          this.paperTotalCount = result.data.total_count;
          this.paperList = result.data.list;
          this.isPaperNull = this.paperList.length > 0;
        })
        .catch(() => {});
    },
    getClassHomeworkInfoList(v) {
      this.getRequest(
        "/wenjiaoopne/kc/teacher/classHomeworkInfoList",
        Object.assign(this.classHomeworkQuery, {
          class_code: v.class_code,
          home_work_code: v.home_work_code,
        })
      )
        .then((result) => {
          this.classHomeworkTotal = result.data.total_count;
          this.classHomeworkList = result.data.list;
        })
        .catch(() => {});
    },
    onSelectType(v) {
      this.classType = v;
      if (v === 1) {
        this.getUserPaperList();
      }
    },
    onOperation(item) {
      this.$set(item, "isShow", !item.isShow || false);
    },
    onUpdatePaper(item) {
      this.$confirm(
        "编辑将清空当前试题篮试题，并把当前试卷题目加入试题篮。",
        "提示",
        {
          type: "warning",
        }
      )
        .then(() => {
          this.getRequest("/wenjiaoopne/kc/basket/work/updateUserPaper", {
            code: item.code,
          })
            .then(() => {
              this.$router.push(
                `/work/browse?code=${item.code}&name=${encodeURIComponent(
                  item.name
                )}&stagecode=${item.stage_code}&subjectcode=${
                  item.subject_code
                }`
              );
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    onDeletePaper(code) {
      this.$confirm("确认删除试卷？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.getRequest("/wenjiaoopne/kc/basket/work/deleteUserPaper", {
            code: code,
          })
            .then(() => {
              this.getUserPaperList();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    onHomeworkTo(item) {
      this.paperIng = item;
      this.dialog = {
        status: true,
        title: "下发作业试卷名称：【" + item.name + "】",
      };
      this.getRequest("/wenjiaoopne/kc/class/get")
        .then((result) => {
          this.classList = result.data;
        })
        .catch(() => {});
    },

    onSetHomeWork(v) {
      this.homeWorkForm.time = "";
      this.homeWorkIng = v;
      this.dialogTime.status = true;
    },

    //作业详情
    onHomeWorkCase(v) {
      this.onLoading();
      this.homeWorkNum = v.question_count;
      this.getClassHomeworkInfoList(v);
      this.getRequest("/wenjiaoopne/kc/teacher/classHomeworkInfo", {
        home_work_code: v.home_work_code,
      })
        .then((result) => {
          this.loading.close();
          this.classHomeworkInfo = result.data;
          this.dialogCase.status = true;
        })
        .catch(() => {
          this.loading.close();
        });
    },

    onSubmitHomeWork() {
      this.$refs.formTimeRef.validate((valid) => {
        if (valid) {
          let _form = {
            code: this.homeWorkIng.home_work_code,
            start_time: this.homeWorkForm.time[0],
            end_time: this.homeWorkForm.time[1],
          };
          this.postRequest("/wenjiaoopne/kc/teacher/setToHomeWork", _form)
            .then((result) => {
              if (result.error_code > 0) {
                this.$message.error(result.message);
                return false;
              }
              if (result.data) {
                this.$message.success(result.message);
                this.dialogTime.status = false;
                this.getToHomeWorkList();
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let _form = {
            code: this.paperIng.code,
            name: this.form.name,
            start_time: this.form.time[0],
            end_time: this.form.time[1],
            class_code: this.form.class_code.join(),
          };
          this.postRequest("/wenjiaoopne/kc/teacher/toHomeWork", _form)
            .then((result) => {
              if (result.error_code > 0) {
                this.$message.error(result.message);
                return false;
              }
              if (result.data) {
                this.$message.success(result.message);
                this.dialog.status = false;
                this.classType = 0;
                this.getToHomeWorkList();
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    paperPageChange(v) {
      this.$set(this.paperQuery, "page", v);
      this.getUserPaperList();
    },
    homeWorkPageChange(v) {
      this.$set(this.homeWorkQuery, "page", v);
      this.getToHomeWorkList();
    },
    classHomeworkPageChange(v) {
      this.$set(this.classHomeworkQuery, "page", v);
      this.getClassHomeworkInfoList();
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.class-admin-container .right-container .right-header {
  height: 130px;
  padding-top: 2px;
}
.class-admin-container .right-container .sign {
  width: 123px;
  height: 49px;
  margin-right: 10px;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/3.png");
  color: #fff;
}
.m-l-r10 {
  margin: 0 10px;
}
.class-admin-container .right-container .active {
  background-image: url("../../assets/images/2.png");
}
.class-admin-container .right-container .right-header-text {
  color: #bcc8dd;
  margin-left: 10px;
}
.class-admin-container .right-container .num {
  display: inline-block;
  color: #40b8ee;
}
.right-main-edit {
  background-color: #f3f6fe;
}
.class-admin-container .right-container .circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-top: 2px;
  background-color: #40b8ee;
  vertical-align: middle;
}
.class-admin-container .right-container .right-main {
  height: 460px;
}
.class-list-container {
  height: 420px;
}
.class-list-container .item-box {
  padding: 0 20px 0 35px;
  height: 120px;
  background-color: #f3f6fe;
  margin-bottom: 4px;
  font-size: 14px;
  color: #8590a7;
}
.class-list-container .item-box .item-left {
  position: relative;
  width: 60%;
}
.class-list-container .item-left .flag {
  position: absolute;
  width: 12px;
  height: 12px;
  top: 12px;
  left: -20px;
  border-radius: 50%;
  background-color: #bcc8dd;
}
.class-list-container .item-left .flag.active {
  background-color: #5dcc0a !important;
}
.class-list-container .item-box .item-left .info {
  padding: 8px 0;
}
.class-list-container .item-box .item-left .item-top {
  font-weight: 600;
  color: #333;
}
.class-list-container .item-box .info-value {
  margin: 0 20px 0 5px;
  color: #bb4850;
}
.item-right-info {
  width: 220px;
}
.class-list-container .item-box .item-right {
  width: 29%;
}
.right-button {
  margin-top: 25px;
}
.right-button-bg {
  color: #fff;
  background-color: #40b8ee;
  border-color: #40b8ee;
}
.item-right-button {
  width: 100px;
}
.list-page {
  padding: 10px 0;
  float: right;
}
.right-form {
  padding: 50px 30px 0 30px;
}
.edit-input {
  width: 300px;
}
.class-box-cheak {
  height: 200px;
  overflow-y: auto;
}
.form-box {
  width: 800px;
  margin: 0 auto;
}
.dialog-case-header {
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  font-size: 14px;
}
.dialog-case-header .c-item-box {
  width: 33%;
  height: 200px;
}
.dialog-case-header .c-item-box .c-item {
  margin: 20px 25px;
}
.dialog-case-header .c-item-b {
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
.dialog-case-header .c-item-a .c-title .class-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #829fbd;
}
.dialog-case-header .c-item-a .c-title {
  margin-bottom: 10px;
}
.dialog-case-header .c-item-a .c-title div {
  display: inline-block;
}
.dialog-case-header .c-item-a .c-title .c-title-text {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #333;
}
.dialog-case-header .not-list-box {
  width: 100%;
  height: 90px;
  overflow-y: auto;
}
.dialog-case-header .m10 {
  margin-top: 5px;
  font-weight: 700;
}
.dialog-case-header .n-item {
  display: inline-block;
  margin: 5px 10px 5px 0;
}
.dialog-case-header .c-item-b .c-title {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #333;
}
.dialog-case-header .c-item-b .c-chart {
  height: 100px;
  margin: 10px 0;
}

.dialog-case-header .c-item-b .s-c-item {
  width: 50%;
  height: 100px;
  text-align: center;
}
.dialog-case-header .c-item-c .c-title {
  border-left: 4px solid #40b8ee;
  font-size: 16px;
  font-weight: 700;
  color: #333;
}
.dialog-case-header .c-user-list {
  height: 60px;
}
.dialog-case .c-head {
  padding: 10px 20px;
}
.dialog-case .table-box {
  padding: 0 20px;
}
.dialog-case .h-title {
  margin-right: 30px;
  font-size: 16px;
  font-weight: 700;
  color: #333;
}
.dialog-case .ml-8 {
  margin-left: 8px;
}
.dialog-case .page-box {
  padding: 5px 0;
}
.dialog-case .c-40B8EE {
  color: #40b8ee;
}
.dialog-case .c-bb4850 {
  color: #bb4850;
}
</style>
